import ProvidersView from '../ProvidersView.vue'
import ProviderList from '../Pages/ProviderList.vue'
import ProviderEditor from '../Pages/ProviderEditor.vue'
import ProviderDetail from '../Pages/ProviderDetail.vue'
import CompliancePage from '../Pages/CompliancePage.vue'
import SettlementList from '../Pages/SettlementList.vue'
import SettlementDetail from '../Pages/SettlementDetail.vue'

// DEF-ADM-018 — Proveedores de servicio.
const routes = [
  {
    path: '/proveedores',
    component: ProvidersView,
    name: 'providers',
    children: [
      {
        path: '',
        name: 'providers-list',
        component: ProviderList
      },
      {
        path: 'create',
        name: 'providers-create',
        component: ProviderEditor
      },
      {
        // DEF-ADM-019 — dashboard de compliance documental.
        path: 'compliance',
        name: 'providers-compliance',
        component: CompliancePage
      },
      {
        // DEF-ADM-021 — liquidaciones. Van antes de ':id' para que no las tome
        // como el id de un proveedor.
        path: 'liquidaciones',
        name: 'settlements-list',
        component: SettlementList
      },
      {
        path: 'liquidaciones/:id',
        name: 'settlements-detail',
        component: SettlementDetail
      },
      {
        path: ':id',
        name: 'providers-detail',
        component: ProviderDetail
      }
    ]
  }
]

export default routes
